import { first, uniqueId } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import ContainedImage from '../../elements/ContainedImage';
import LeftTabbedGrayHeader from '../../elements/headers/LeftTabbedGrayHeader';
import Scrollable from '../../elements/Scrollable';
import TopBar from '../../elements/TopBar/TopBar';
import Screen from '../Screen';
import styles from './MyProfile.module.scss';
import ActionButton from '../../elements/ActionButton/ActionButton';

class MyProfileScreen_Photo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inputKey: uniqueId(),
        };
    }
    render() {
        var { i18n, currentAvatar } = this.props,
            header = (
                <>
                    <TopBar returnURL=".."></TopBar>
                    <hr />
                </>
            );

        return (
            <Screen header={header}>
                <Scrollable>
                    <LeftTabbedGrayHeader>{i18n['label.changePhoto.title']}</LeftTabbedGrayHeader>
                    <div className="indent">
                        <div
                            style={{
                                position: 'relative',
                                paddingLeft: 60,
                            }}>
                            <ContainedImage
                                src={currentAvatar}
                                altSrc="img/no_avatar.png"
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: 50,
                                    height: 50,
                                }}></ContainedImage>
                            <ActionButton className={styles.ActionButton} next tab primary onClick={this.handleCapturePhoto.bind(this)}>
                                {i18n['label.take.Photo']}
                            </ActionButton>
                            <ActionButton className={styles.ActionButton} next tab primary onClick={this.handleGalleryPhoto.bind(this)}>
                                {i18n['label.choose.Photo']}
                            </ActionButton>
                        </div>
                    </div>
                    <input
                        ref={(el) => (this.refs.image = el)}
                        type="file"
                        accept="image/jpeg"
                        style={{
                            visibility: 'hidden',
                        }}
                        onChange={this.handleImageSelected.bind(this)}
                        key={this.inputKey}
                    />
                </Scrollable>
            </Screen>
        );
    }
    handleCapturePhoto() {
        this.refs.image.capture = true;
        this.refs.image.click();
    }
    handleGalleryPhoto() {
        this.refs.image.removeAttribute('capture');
        this.refs.image.click();
    }
    handleImageSelected(e) {
        var file = first(e.target.files);
        if (file) {
            app.api.users
                .uploadPhoto(this.props.userId, file)
                .then(() => {
                    app.history.push('/my_profile');
                })
                .catch((e) => {
                    console.error(e);
                    this.setState({ inputKey: uniqueId() });
                });
        }
    }
}

export default connect(function (state, props) {
    return {
        i18n: state.i18n.translations,
        userId: state.session.user.id,
        currentAvatar: state.session.user.image_url,
    };
})(MyProfileScreen_Photo);
